import { RC, type ResponseCode } from './responseCodes'

// 인증 관련 에러 메시지 상수
export const AUTH_MESSAGES = {
  // 로그인
  LOGIN_REQUIRED_FIELDS: '올바른 아이디와 비밀번호를 입력해주세요.',
  LOGIN_FAILED: '로그인에 실패했습니다.',
  LOGIN_SUCCESS: '로그인되었습니다.',
  INVALID_CREDENTIALS: '로그인 정보가 일치하지 않습니다.',
  INVALID_AUTH_INFO: '인증 정보가 올바르지 않습니다.',
  INVALID_AUTH: '인증 정보가 유효하지 않습니다.',
  AUTH_FAILED: '인증에 실패했습니다.',

  // 세션/토큰
  SESSION_EXPIRED: '로그인 세션이 만료되었습니다.',
  SESSION_EXPIRED_LOGOUT: '세션이 만료되어 로그아웃되었습니다.',
  TOKEN_VERIFY_FAILED: '토큰 검증 실패',

  // 로그아웃
  LOGOUT: '로그아웃',
  LOGOUT_SUCCESS: '로그아웃되었습니다.',
  LOGOUT_ERROR: '로그아웃 중 오류가 발생했습니다.',

  // 회원 탈퇴
  WITHDRAW_FAILED: '회원 탈퇴에 실패했습니다.',
  WITHDRAW_SUCCESS: '회원이 탈퇴되었습니다.',

  // 이메일 인증
  EMAIL_REQUIRED: '올바른 이메일 주소를 입력해주세요.',
  EMAIL_CODE_REQUIRED: '인증번호를 입력해주세요.',
  EMAIL_CODE_SEND_FAILED: '인증번호 발송에 실패했습니다.',
  EMAIL_CODE_MISMATCH: '인증번호가 일치하지 않습니다.',
  EMAIL_CODE_EXPIRED: '인증번호가 만료되었습니다. 다시 시도해주세요.',
  EMAIL_VERIFY_FAILED: '인증에 실패했습니다.',

  // 회원가입
  SIGNUP_FAILED: '회원가입에 실패했습니다.',
  SIGNUP_TERMS_REQUIRED: '이용약관 및 개인정보처리방침에 동의해주세요.',

  // 권한
  FORBIDDEN: '접근 권한이 없습니다.',

  // 리소스
  NOT_FOUND: '서비스를 찾을 수 없습니다.',

  // 요청 제한
  TOO_MANY_REQUESTS: '너무 많은 요청이 발생했습니다. 잠시 후 다시 시도해주세요.',

  // 서버
  SERVER_ERROR: '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
  BAD_REQUEST: '입력 정보를 확인해주세요.',

  // 네트워크
  NETWORK_ERROR: '네트워크 연결을 확인해주세요.',

  // 일반
  REQUEST_ERROR: '요청 처리 중 오류가 발생했습니다.',
} as const

// 필수 약관 목록
export const REQUIRED_AGREEMENTS = ['TERMS_OF_SERVICE', 'PRIVACY_POLICY'] as const
export type RequiredAgreement = (typeof REQUIRED_AGREEMENTS)[number]

// 로그인 에러 코드 - 메시지 맵
export const LOGIN_ERROR_CODE_MAP: Partial<Record<ResponseCode, string>> = {
  [RC.INVALID_CREDENTIALS]: AUTH_MESSAGES.INVALID_CREDENTIALS,
  [RC.INVALID_TOKEN]: AUTH_MESSAGES.INVALID_AUTH,
  [RC.EXPIRED_TOKEN]: AUTH_MESSAGES.INVALID_AUTH,
  [RC.AUTHENTICATION_FAILED]: AUTH_MESSAGES.AUTH_FAILED,
}

// 401 에러 코드 - 로그아웃 메시지 맵
export const API_401_ERROR_MAP: Partial<Record<ResponseCode, string>> = {
  [RC.EXPIRED_TOKEN]: AUTH_MESSAGES.SESSION_EXPIRED_LOGOUT,
  [RC.INVALID_TOKEN]: AUTH_MESSAGES.INVALID_AUTH,
  [RC.UNAUTHORIZED]: AUTH_MESSAGES.INVALID_AUTH,
}

// HTTP 상태 코드 - 에러 메시지 맵
export const HTTP_STATUS_ERROR_MAP: Record<number, string> = {
  400: AUTH_MESSAGES.BAD_REQUEST,
  403: AUTH_MESSAGES.FORBIDDEN,
  404: AUTH_MESSAGES.NOT_FOUND,
  429: AUTH_MESSAGES.TOO_MANY_REQUESTS,
  500: AUTH_MESSAGES.SERVER_ERROR,
}
